module.exports = __webpack_public_path__ + "static/img/nav_logo_blue.537f9ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav_logo_blue.svg
// module id = r7QG
// module chunks = 5